<!--

 -->

<template>
  <div class="gsl-hrm-profile-picture">
    <img
      :src="imgSrc"
      alt="Profile Picture"
      class="gsl-hrm-profile-picture-img"
    />
  </div>
</template>

<script>
import {computed} from 'vue';

const defaultPic = `${window.appGlobal.publicPath}/images/default-photo.png`;

export default {
  name: 'ProfilePicture',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const imgSrc = computed(() => {
      return props.id
        ? `${window.appGlobal.baseUrl}/pim/viewPhoto/empNumber/${props.id}`
        : defaultPic;
    });
    return {
      imgSrc,
    };
  },
};
</script>

<style lang="scss" scoped>
.gsl-hrm-profile-picture {
  display: block;
  height: 90px;
  width: 90px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 50%;
  border: $oxd-primary-one-color 4px solid;
  & img {
    height: 90px;
    width: 90px;
    object-fit: cover;
    object-position: top;
  }
}
</style>
